import Title from "./Title";
import { useTranslation } from "react-i18next";

export default function ContactForm() {
  const { t } = useTranslation();
  return (
    <section id={t("link-contact")} className="contact-section section">
      <Title title={t("contact-title")} />

      <div className="contact-links-wrapper">
        <div className="link-wrapper">
          <h3>{t("email")}</h3>
          <a href="mailto:violaprinz@web.de">violaprinz@web.de</a>
        </div>
        <div className="link-wrapper">
          <h3>{t("telephone")}</h3>
          <a href="tel:+4915227583299">01522 7583299</a>
        </div>

        <div className="link-wrapper">
          <h3>LinkedIn:</h3>
          <a
            href="https://www.linkedin.com/in/viola-prinz-646b6615b/"
            target="_blank"
            rel="noreferrer"
          >
            Viola Prinz
          </a>
        </div>
      </div>
    </section>
  );
}
